import React, { useEffect, useState } from "react";
import "./SignUpSuccessfull.css";
import { useDispatch } from "react-redux";
import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
import { useNavigate } from "react-router-dom";
import { getToken, getUserId, tokenStorage } from "../../../api/index";
import { getRedirectPath, clearRedirectPath } from "../../../utils/authRedirect";

function SignUpSuccessfull() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check authentication status on component mount
  useEffect(() => {
    const checkAuth = () => {
      const token = getToken();
      const userId = getUserId();
      const authenticated = !!(token && userId);
      setIsAuthenticated(authenticated);
      console.log("SignUpSuccessfull - Auth check on mount:", {
        token: !!token,
        userId: !!userId,
        authenticated,
      });
    };

    // Check immediately and also after a short delay to ensure tokens are set
    checkAuth();
    const timeoutId = setTimeout(checkAuth, 100);

    return () => clearTimeout(timeoutId);
  }, []);

  const handleGoToDashboardClick = () => {
    // Check if user is authenticated before navigating
    const token = getToken();
    const userId = getUserId();

    console.log("SignUpSuccessfull - Token check:", {
      token: !!token,
      userId: !!userId,
    });

    if (token && userId) {
      console.log("User is authenticated, navigating to target");
      const target = getRedirectPath();
      clearRedirectPath();
      navigate(target, { replace: true });
    } else {
      console.log("User not authenticated, redirecting to signin");
      // If not authenticated, redirect to signin
      navigate("/login" + window.location.search);
      dispatch(setActiveComponent("signIn"));
    }
  };

  const handleGoToSignInClick = () => {
    navigate("/login" + window.location.search);
    dispatch(setActiveComponent("signIn"));
  };

  return (
    <div className="PasswordChanges">
      <div className="passwordChangedContainer">
        <span className="signInText">Sign Up Successfull</span>
        {/* <span className="signInText2"> Sign Up Successfull</span> */}
        <img
          src="/Assets/PasswordChanged/TickIcon.svg"
          alt="no img found"
          className="tickIcon"
        />
        {/* <div className="backToLoginContainer"> */}
        <button className="btnContainer" onClick={handleGoToDashboardClick}>
          <span className="btnText">
            {isAuthenticated
              ? (getRedirectPath()?.startsWith("/facilitate") || getRedirectPath()?.startsWith("/adventure") ? "Go to Dashboard" : "Go to Ballots")
              : (getRedirectPath()?.startsWith("/facilitate") || getRedirectPath()?.startsWith("/adventure") ? "Go to Dashboard (Checking...)" : "Go to Ballots (Checking...)")}
          </span>
        </button>
        {/* </div> */}
        {/* <div className="backToLoginContainer"> */}
        <button className="btnContainer" onClick={handleGoToSignInClick}>
          <span className="btnText">Back To Sign In</span>
        </button>
        {/* </div> */}
      </div>
    </div>
  );
}

export default SignUpSuccessfull;
